module.exports = __webpack_public_path__ + "img/tpc-2.c5c89aca.jpg";